import { PropsWithChildren } from 'react'
import styled, { useTheme } from 'styled-components'
import { FancySwitch } from '../FancySwitch/FancySwitch'
import { Box, Typography } from '@material-ui/core'
import Brightness3OutlinedIcon from '@material-ui/icons/Brightness3Outlined'
import Brightness7Icon from '@material-ui/icons/Brightness7'
import { Switch } from '../Switch/Switch'
import { SwitchDesignModes } from '../Switch/Switch.types'

type ThemeMode = 'dark' | 'light'

export interface IModeSwitchProps {
  /** A string representing the current theme mode: dark or light */
  mode: ThemeMode

  /** Function run when user clicks on switch */
  onChange?: (mode: ThemeMode) => void
}

export const ModeSwitch = ({ mode, onChange }: PropsWithChildren<IModeSwitchProps>) => {
  return (
    <>
      <Switch
        design={SwitchDesignModes.MODE_SWITCH}
        onChange={isOn => {
          onChange?.(isOn ? 'dark' : 'light')
        }}
        state={mode == 'dark' ? true : false}
      />
    </>
  )
}
